@if (isLoading) {
<ng-casto-loader></ng-casto-loader>
} @else {
<ng-container [ngSwitch]="modalService.currentId">
  <ng-casto-login *ngSwitchCase="MODAL.LOGIN"></ng-casto-login>
  <ng-casto-register class="content" *ngSwitchCase="MODAL.REGISTER"></ng-casto-register>

  <ng-casto-register-customer *ngSwitchCase="MODAL.REGISTER_CUSTOMER"></ng-casto-register-customer>
  <ng-casto-projects class="content" *ngSwitchCase="MODAL.PROJECTS"></ng-casto-projects>
  <ng-casto-price-infos class="content" *ngSwitchCase="MODAL.PRICE_INFOS"></ng-casto-price-infos>
  <ng-casto-products-list class="content" *ngSwitchCase="MODAL.PRODUCTS_LIST"></ng-casto-products-list>
  <ng-casto-debug-infos class="content" *ngSwitchCase="MODAL.DEBUG_INFOS"></ng-casto-debug-infos>
  <ng-casto-image-zoom *ngSwitchCase="MODAL.IMAGE_ZOOM"></ng-casto-image-zoom>
  <ng-casto-print-medias class="content" *ngSwitchCase="MODAL.PRINT_MEDIAS"></ng-casto-print-medias>
  <ng-casto-contact class="content" *ngSwitchCase="MODAL.CONTACT"></ng-casto-contact>
  <ng-casto-logout *ngSwitchCase="MODAL.LOGOUT"></ng-casto-logout>
  <ng-casto-project-delete *ngSwitchCase="MODAL.PROJECT_DELETE"></ng-casto-project-delete>
  <ng-casto-project-duplicate *ngSwitchCase="MODAL.PROJECT_DUPLICATE"></ng-casto-project-duplicate>
  <ng-casto-message *ngSwitchCase="MODAL.MESSAGE"></ng-casto-message>
  <ng-casto-inspiration-tip class="content" *ngSwitchCase="MODAL.INSPIRATION_TIP"></ng-casto-inspiration-tip>
  <ng-casto-confirm-forgotten-password
    *ngSwitchCase="MODAL.CONFIRM_FORGOTTEN_PASSWORD"></ng-casto-confirm-forgotten-password>
  <ng-casto-order-products class="content" *ngSwitchCase="MODAL.ORDER_PRODUCTS"></ng-casto-order-products>
  <ng-casto-installation-quote class="content" *ngSwitchCase="MODAL.INSTALLATION_QUOTE"></ng-casto-installation-quote>
  <ng-casto-closet-doors-quote class="content" *ngSwitchCase="MODAL.CLOSET_DOORS_QUOTE"></ng-casto-closet-doors-quote>
  <ng-casto-closet-doors-percentage class="content"
    *ngSwitchCase="MODAL.CLOSET_DOORS_PERCENTAGE"></ng-casto-closet-doors-percentage>
  <ng-casto-closet-doors-administration-message class="content"
    *ngSwitchCase="MODAL.CLOSET_DOORS_ADMINISTRATION_MESSAGE"></ng-casto-closet-doors-administration-message>
  <ng-casto-closet-doors-structure-info class="content"
    *ngSwitchCase="MODAL.CLOSET_DOORS_STRUCTURE_INFO"></ng-casto-closet-doors-structure-info>
  <ng-casto-closet-doors-plinth-info class="content"
    *ngSwitchCase="MODAL.CLOSET_DOORS_PLINTH_INFO"></ng-casto-closet-doors-plinth-info>
  <ng-casto-generic-error class="content" *ngSwitchCase="MODAL.GENERIC_ERROR"></ng-casto-generic-error>
  <ng-casto-generic-error-customer class="content"
    *ngSwitchCase="MODAL.GENERIC_ERROR_CUSTOMER"></ng-casto-generic-error-customer>
  <ng-casto-decking-boards-class-info class="content"
    *ngSwitchCase="MODAL.DECKING_BOARDS_CLASS_INFO"></ng-casto-decking-boards-class-info>
  <ng-casto-fence-infos-angle-kit class="content"
    *ngSwitchCase="MODAL.FENCE_INFOS_ANGLE_KIT"></ng-casto-fence-infos-angle-kit>
  <ng-casto-fence-infos-base-plate class="content"
    *ngSwitchCase="MODAL.FENCE_INFOS_BASE_PLATE"></ng-casto-fence-infos-base-plate>
  <ng-casto-appointment-link class="content" *ngSwitchCase="MODAL.APPOINTMENT_LINK"></ng-casto-appointment-link>
  <ng-casto-generic-info class="content" *ngSwitchCase="MODAL.GENERIC_INFO"></ng-casto-generic-info>
  <ng-casto-basket-confirmation *ngSwitchCase="MODAL.BASKET_CONFIRMATION"></ng-casto-basket-confirmation>
</ng-container>
}